// extracted by mini-css-extract-plugin
export default {"content":"success-screen_content__95nIJ","title":"success-screen_title__yX8vY","subtitle":"success-screen_subtitle__LHUFG","button":"success-screen_button__vx9lY"};